(ns client-login.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    )
  )

(rf/reg-event-fx
 :sso-login
 (fn [cfx [svc]]
   {:graphql {:gql (qu/client-sso)
              :success [:maybe-sso-redirect svc]
              :error [:sso-failure]
              :failure [:sso-failure]
              }}))

(rf/reg-event-fx
  :maybe-sso-redirect
  (fn [cfx [svc {:keys [client]}]]
    ;; if the sso comes back null, they're not allowed to redirect
    (if (get-in client [:sso svc])
      (.open js/window (get-in client [:sso svc]))
      {:dispatch [:sso-failure]})))

(rf/reg-event-fx
  :sso-failure
  (fn [cfx]
    {:dispatch [:error-message "Please contact your advisor to setup your Client Experience Optimizer account."]}))
